export const PHONE_YGT = "08000436644";
export const DOWNLOAD_PDF = "download-pdf";